import request from '@/utils/request';
import { PageResult } from '@/api/typing';

export async function updatete_c_c_bank_accounts_c_c(params: Record<string, any>) {
  return request.post('/baseinfo/updatete_c_c_bank_accounts_c_c', params);
}

export async function update_c_c_bank_accounts_c_c(params: Record<string, any>) {
  return request.post('/baseinfo/update_c_c_bank_accounts_c_c', params);
}

export async function delete_c_c_bank_accounts_c_c(params: Record<string, any>) {
  return request.post('/baseinfo/delete_c_c_bank_accounts_c_c', params);
}

export async function recover_c_c_bank_accounts_c_c(params: Record<string, any>) {
  return request.post('/baseinfo/recover_c_c_bank_accounts_c_c', params);
}

export async function query_c_c_bank_accounts_c_c_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/baseinfo/query_c_c_bank_accounts_c_c_list', params);
}

export async function updatete_country(params: Record<string, any>) {
  return request.post('/baseinfo/create_country', params);
}

export async function update_country(params: Record<string, any>) {
  return request.post('/baseinfo/update_country', params);
}

export async function delete_country(params: Record<string, any>) {
  return request.post('/baseinfo/delete_country', params);
}

export async function recover_country(params: Record<string, any>) {
  return request.post('/baseinfo/recover_country', params);
}

export async function query_country_by_select_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/baseinfo/query_country_by_select_list', params);
}

export async function query_country_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/baseinfo/query_country_list', params);
}

export async function create_id_type(params: Record<string, any>) {
  return request.post('/baseinfo/create_id_type', params);
}

export async function update_id_type(params: Record<string, any>) {
  return request.post('/baseinfo/update_id_type', params);
}

export async function delete_id_type(params: Record<string, any>) {
  return request.post('/baseinfo/delete_id_type', params);
}

export async function recover_id_type(params: Record<string, any>) {
  return request.post('/baseinfo/recover_id_type', params);
}

export async function query_id_type_by_select_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/baseinfo/query_id_type_by_select_list', params);
}

export async function query_id_type_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/baseinfo/query_id_type_list', params);
}

export async function create_insurance_company(params: Record<string, any>) {
  return request.post('/baseinfo/create_insurance_company', params);
}

export async function update_insurance_company(params: Record<string, any>) {
  return request.post('/baseinfo/update_insurance_company', params);
}

export async function delete_insurance_company(params: Record<string, any>) {
  return request.post('/baseinfo/delete_insurance_company', params);
}

export async function recover_insurance_company(params: Record<string, any>) {
  return request.post('/baseinfo/recover_insurance_company', params);
}

export async function query_insurance_company_by_select_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/baseinfo/query_insurance_company_by_select_list', params);
}

export async function query_insurance_company_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/baseinfo/query_insurance_company_list', params);
}

export async function create_invoice_type(params: Record<string, any>) {
  return request.post('/baseinfo/create_invoice_type', params);
}

export async function update_invoice_type(params: Record<string, any>) {
  return request.post('/baseinfo/update_invoice_type', params);
}

export async function delete_invoice_type(params: Record<string, any>) {
  return request.post('/baseinfo/delete_invoice_type', params);
}

export async function recover_invoice_type(params: Record<string, any>) {
  return request.post('/baseinfo/recover_invoice_type', params);
}

export async function query_invoice_type_by_select_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/baseinfo/query_invoice_type_by_select_list', params);
}

export async function query_invoice_type_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/baseinfo/query_invoice_type_list', params);
}

export async function create_note_type(params: Record<string, any>) {
  return request.post('/baseinfo/create_note_type', params);
}

export async function update_note_type(params: Record<string, any>) {
  return request.post('/baseinfo/update_note_type', params);
}

export async function delete_note_type(params: Record<string, any>) {
  return request.post('/baseinfo/delete_note_type', params);
}

export async function recover_note_type(params: Record<string, any>) {
  return request.post('/baseinfo/recover_note_type', params);
}

export async function query_note_type_by_select_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/baseinfo/query_note_type_by_select_list', params);
}

export async function query_note_type_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/baseinfo/query_note_type_list', params);
}

export async function create_person_type(params: Record<string, any>) {
  return request.post('/baseinfo/create_person_type', params);
}

export async function update_person_type(params: Record<string, any>) {
  return request.post('/baseinfo/update_person_type', params);
}

export async function delete_person_type(params: Record<string, any>) {
  return request.post('/baseinfo/delete_person_type', params);
}

export async function recover_person_type(params: Record<string, any>) {
  return request.post('/baseinfo/recover_person_type', params);
}

export async function query_person_type_by_select_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/baseinfo/query_person_type_by_select_list', params);
}

export async function query_person_type_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/baseinfo/query_person_type_list', params);
}

export async function create_recuitment_company(params: Record<string, any>) {
  return request.post('/baseinfo/create_recuitment_company', params);
}

export async function update_recuitment_company(params: Record<string, any>) {
  return request.post('/baseinfo/update_recuitment_company', params);
}

export async function delete_recuitment_company(params: Record<string, any>) {
  return request.post('/baseinfo/delete_recuitment_company', params);
}

export async function recover_recuitment_company(params: Record<string, any>) {
  return request.post('/baseinfo/recover_recuitment_company', params);
}

export async function query_recuitment_company_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/baseinfo/query_recuitment_company_list', params);
}

export async function create_reference_number_type(params: Record<string, any>) {
  return request.post('/baseinfo/create_reference_number_type', params);
}

export async function update_reference_number_type(params: Record<string, any>) {
  return request.post('/baseinfo/update_reference_number_type', params);
}

export async function delete_reference_number_type(params: Record<string, any>) {
  return request.post('/baseinfo/delete_reference_number_type', params);
}

export async function recover_reference_number_type(params: Record<string, any>) {
  return request.post('/baseinfo/recover_reference_number_type', params);
}

export async function query_reference_number_type_by_select_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/baseinfo/query_reference_number_type_by_select_list', params);
}

export async function query_reference_number_type_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/baseinfo/query_reference_number_type_list', params);
}

export async function create_status(params: Record<string, any>) {
  return request.post('/baseinfo/create_status', params);
}

export async function update_status(params: Record<string, any>) {
  return request.post('/baseinfo/update_status', params);
}

export async function delete_status(params: Record<string, any>) {
  return request.post('/baseinfo/delete_status', params);
}

export async function recover_status(params: Record<string, any>) {
  return request.post('/baseinfo/recover_status', params);
}

export async function query_status_by_select_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/baseinfo/query_status_by_select_list', params);
}

export async function query_status_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/baseinfo/query_status_list', params);
}
